/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {FeedbackCategory, Feedback_KeyFreeText} from "@app/app-shared/alert";

export const feedbackCategories: FeedbackCategory[] = [
	{
		key: "clinical_action",
		label: "Clinical actions",
		options: [
			{
				key: "medication_dose_adjusted",
				label: "Adjusted medication dosage"
			},
			{
				key: "care_plan_updated_or_new_instructions_to_patient",
				label: "Updated care plan / New instructions to patient"
			},
			{
				key: "arranged_medication_pickup",
				label: "Arranged medication pickup"
			},
			{
				key: "approved_medication_refill",
				label: "Approved medication refill"
			},
			{
				key: "obtained_prior_authorization_for_medicine_or_substitute_medication",
				label: "Obtained authorization for new or substitute medication"
			}
		]
	},
	{
		key: "follow_up",
		label: "Follow up",
		options: [
			{
				key: "scheduled_follow_up_visit",
				label: "Scheduled follow up visit"
			},
			{
				key: "sent_to_a_physician_for_review_or_consultation",
				label: "Sent to a physician for review or consultation"
			},
			{
				key: "ordered_tests",
				label: "Ordered tests (blood, imaging, other)"
			}
		]
	},
	{
		key: "patient_engagement",
		label: "Customer engagement",
		options: [
			{
				key: "provided_teaching_or_education",
				label: "Provided teaching/education"
			},
			{
				key: "no_clinical_action_required",
				label: "No clinical action required: social call, etc"
			},
			{
				key: 'contact_request_not_necessary',
				label: 'Contact request from patient was not necessary'
			},
			{
				key: "patient_declined_further_follow_up",
				label: "Customer declined further follow up"
			},
			{
				key: "false_alarm",
				label: "False alarm"
			}
		]
	},
	{
		key: "community_engagement",
		label: "Community engagement",
		options: [
			{
				key: "activated_caregiver_to_assist_the_patient",
				label: "Activated Caregiver to assist the patient"
			},
			{
				key: "outreach_to_community_services",
				label: "Outreach to community services (transit, food services etc.)"
			}
		]
	},
	{
		key: "other",
		label: "Other",
		options: [
			{
				key: "alert_already_known",
				label: "Reported notification is already known"
			},
			{
				key: Feedback_KeyFreeText,
				label: ""
			}
		]
	}
];
